import PageHeader from "../../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import TogglePushBtn from "../../../../components/Universal/TogglePushBtn.component";
import FilterBtn from "../../../../components/Universal/FilterBtn.component";

import { ReactComponent as PersonIcon } from "../../../../assets/Icons/Universal/Person.svg";
import { ReactComponent as PersonInMobileIcon } from "../../../../assets/Icons/Universal/PersonInMobile.svg";

// import PersonIcon from "../../../../assets/Icons/Pages/Operational/Academic/Dashboard/People.svg"
import PeopleIcon from "../../../../assets/Icons/Pages/Operational/Academic/Dashboard/People.svg";
import SinglePerson from "../../../../assets/Icons/Pages/Operational/Academic/Dashboard/SinglePerson.svg";
import CalendarIcon from "../../../../assets/Icons/Pages/Operational/Academic/Dashboard/Calendar.svg";
import BookIcon from "../../../../assets/Icons/Pages/Operational/Academic/Dashboard/Book.svg";
import DashboardOverviewCard from "../../../../components/PagesComponents/Organizational/Management/Dashboard/OverviewCard.components";
import ScrollableShortCard from "../../../../components/Universal/ScrollableShortCard.component";
import ScrollableShortCardComponentCard from "../../../../components/PagesComponents/Operational/Academic/Dashboard/ScrollableShortCardComponentCard.component";
import IndivisualMemberCard from "../../../../components/PagesComponents/Organizational/Management/Members/IndivisualMemberCard.component";
import TableCard from "../../../../components/Universal/TableCard.component";
import LineChart from "../../../../components/PagesComponents/Operational/Residential/Dashboard/LineChart.component";
import { Helmet } from "react-helmet";
const OverviewCardTitleToIcon = {
  Students: SinglePerson,
  Teachers: PeopleIcon,
  "Today's Events": CalendarIcon,
  "Rest of the books": BookIcon,
};
const Body = ({
  classesFilter,
  setClassesFilter,
  genderWaysFilter,
  setGenderWaysFilter,
  overViewCardData,
  lineChartData,
  setLineChartFilter,
  absenteesData,
  onleaveData,

  staffAppearanceData,
  tuitionScheduleData,
}) => {
  return (
    <section className="w-full flex-col align-start justify-start g-1">
      <Helmet>
        <title>Dashboard</title>
      </Helmet>
      <PageHeader
        renderCustomElement={
          <div
            className="flex-row align-center justify-start g-05"
            style={{ flexWrap: "wrap" }}
          >
            <TogglePushBtn
              type="radio"
              setVal={(val) => setGenderWaysFilter(val)}
              name="examreportToggle"
              value={genderWaysFilter}
              icon={
                <PersonIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="All"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) => setGenderWaysFilter(val)}
              name="examreportToggle"
              value={genderWaysFilter}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Boys"
            />
            <TogglePushBtn
              type="radio"
              setVal={(val) => setGenderWaysFilter(val)}
              name="examreportToggle"
              value={genderWaysFilter}
              icon={
                <PersonInMobileIcon
                  fill="white"
                  style={{ width: "1.3rem", height: "1.3rem" }}
                />
              }
              icontype="svg"
              label="Girls"
            />
            <FilterBtn
              btnTitle={"Filter"}
              filterArray={[
                "Class I",
                "Class II",
                "Class III",
                "Class IV",
                "Class V",
              ]}
              setFilteredData={(val) => setClassesFilter(val)}
              filteredData={classesFilter}
            />
          </div>
        }
      />

      {/* dashboard overview cards  */}
      <div className="flex-row align-center  justify-start g-1">
        {overViewCardData &&
          overViewCardData.map((data, index) => {
            const { title, presentCount, cardType = "regular", bgColor } = data; // Destructure cardType
            const IconComponent = OverviewCardTitleToIcon[title];

            return (
              <DashboardOverviewCard
                key={index}
                icon={cardType === "regular" ? IconComponent : null} // Condition for icon
                cardType={cardType} // Pass cardType prop
                title={title}
                presentCount={presentCount}
                bgColor={bgColor}
              />
            );
          })}
      </div>

      {/* main body grid type structures  */}
      <div className="flex-row align-start justify-start g-1">
        {/* left side container */}
        <div className="w-half flex-col align-start justify-start g-1">
          {/* left top overview graph */}
          <LineChart
            graphData={lineChartData}
            graphTitle="All residential students and staffs"
            graphFilter={(val) => setLineChartFilter(val)}
          />

          <div
            className="flex-row align-start justify-start g-1"
            style={{ height: "55vh" }}
          >
            <div className="w-half  radius-6 p-1 back-white">
              <ScrollableShortCard
                title="Absentees"
                actionBtn={
                  <div>
                    <span className="color-greenColor t-12">
                      {absenteesData?.length} students
                    </span>
                  </div>
                }
              >
                {absenteesData &&
                  absenteesData?.map((data) => {
                    return (
                      <ScrollableShortCardComponentCard
                        name={data.name}
                        date={data.date}
                        studentClass={data.class}
                        image={data.image}
                        _id={data.id}
                      />
                    );
                  })}
              </ScrollableShortCard>
            </div>
            <div className="w-half  p-1 radius-6 back-white">
              <ScrollableShortCard
                title="On Leave"
                actionBtn={
                  <div>
                    <span className="color-greenColor t-12">
                      {onleaveData?.length} persons
                    </span>
                  </div>
                }
              >
                {onleaveData &&
                  onleaveData?.map((data) => {
                    return (
                      <ScrollableShortCardComponentCard
                        name={data.name}
                        date={data.date}
                        studentClass={data.designation}
                        image={data.image}
                        _id={data.id}
                      />
                    );
                  })}
              </ScrollableShortCard>
            </div>
          </div>
        </div>
        {/* right side parent container */}
        <div className="w-half flex-col align-start justify-start g-1">
          {/* right top, class wise attendance chart */}
          <div
            className=" back-white p-2 radius-6 flex-col align-start justify-start g-1"
            style={{ height: "56vh" }}
          >
            <div className="w-full h-full">
              <TableCard
                tableHead={["Persons", "Designation", "Today's appearence"]}
                title={"Important appearance"}
              >
                {staffAppearanceData &&
                  staffAppearanceData?.map((data, index) => (
                    <IndivisualMemberCard
                      key={data.id}
                      image={data.image}
                      name={data.name}
                      profileId={data.staffId}
                      designation={data.designation}
                      percentage={data.time}
                    />
                  ))}
              </TableCard>
            </div>
          </div>
          <div
            className=" back-white p-2 radius-6 flex-col align-start justify-start g-1"
            style={{ height: "56vh" }}
          >
            <div className="w-full h-full">
              <TableCard
                tableHead={["Student name", "Class", "Total Points"]}
                title={"Tuition schedules"}
              >
                {tuitionScheduleData &&
                  tuitionScheduleData?.map((data, index) => (
                    <tr className="dashboardTuitionScheduleTableTr" >
                      <td className="t-14 pb-1 pt-1">{data.shift}</td>
                      <td className="pb-1 pt-1">{data.batches}</td>
                      <td className="pb-1 pt-1">{data.totalStudents}</td>
                    </tr>
                  ))}
              </TableCard>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Body;
